import React, { useEffect, useState } from "react";
import "./training-trainer.scss";
import { withStyles } from "@material-ui/core/styles";
import Tabs from "@material-ui/core/Tabs";
import Tab from "@material-ui/core/Tab";
import Dialog from "@material-ui/core/Dialog";
import DialogContent from "@material-ui/core/DialogContent";
import TextField from "@material-ui/core/TextField";
import DialogActions from "@material-ui/core/DialogActions";
import Button from "@material-ui/core/Button";
import Select from "@material-ui/core/Select";
import MenuItem from "@material-ui/core/MenuItem";
import { useDispatch, useSelector } from "react-redux";
import DialogTitle from "../hoc/dialog-title";
import { Scrollbars } from "react-custom-scrollbars";
import { compose } from "redux";
import { withRouter } from "react-router";
import { useTrainingContainer } from "../hooks/useTrainingContainer";
import moment from "moment";
import StatusTraining from "../main/component/status-training";
import {
  addEventTraining,
  loadedTraining,
  updateStateChildTraining,
} from "../../../store/actions/trainer";
import Spinner from "../../../components/spinner";
import withApiService from "../../../components/hoc/with-api-service";

import { Box } from "@material-ui/core";
import { createInvoiceForTrainer } from "../../../store/actions/invoice";
import { useSnackbar } from "notistack";
import GroupTab from "./components/GroupTab";
import TabPanel from "./components/TabPanel";
import { state_training_children } from "./constants";
import AttendanceTab from "./components/AttendanceTab";
import Events from "./components/Events";
import EventsTab from "./components/EventsTab";

export const AntTabs = withStyles({
  root: {
    borderBottom: "none",
    marginBottom: "20px",
  },
  indicator: {
    backgroundColor: "#454545",
  },
})(Tabs);

const AntTab = withStyles((theme) => ({
  root: {
    textTransform: "none",
    minWidth: 72,
    fontWeight: theme.typography.fontWeightRegular,
    fontFamily: [
      "Apple SD Gothic Neo",
      "-apple-system",
      "BlinkMacSystemFont",
      '"Segoe UI"',
      "Roboto",
      '"Helvetica Neue"',
      "Arial",
      "sans-serif",
      '"Apple Color Emoji"',
      '"Segoe UI Emoji"',
      '"Segoe UI Symbol"',
    ].join(","),
    "&:hover": {
      color: "#40a9ff",
      opacity: 1,
    },
    /*    "&$selected": {
          color: "#454545",
          fontWeight: 700
        },*/
    "&:focus": {
      color: "#454545",
    },
  },
}))((props) => <Tab disableRipple {...props} />);

const TrainingTrainer = (props) => {
  const { id } = props;
  const training = useSelector((state) => state.trainer.training);
  const user = useSelector((state) => state.auth.user);
  const loading = useSelector((state) => state.trainer.loadingTraining);
  const loadingStatus = useSelector((state) => state.trainer.loadingStatus);
  /*  const state_training_children = useSelector(
    state => state.trainer.state_training_children
  );*/
  const dispatch = useDispatch();
  const [value, setValue] = useState(0);
  const [openChild, setOpenChild] = useState(false);
  /*  const [openChangeTime, setOpenChangeTime] = useState(false);*/
  const [childName, setChildName] = useState("");
  const [trainingId, setTrainingId] = useState(null);
  const [status, setStatus] = useState({ name: "" });
  const [comment, setComment] = useState("");
  /*  const [duration, setDuration] = useState(0);
  const [date, setDate] = useState("");*/
  const [content, setContent] = useState("");
  const [confirmAddInvoice, setConfirmAddInvoice] = useState(false);
  const [confirmChild, setConfirmChild] = useState(null);

  const newTraining = useTrainingContainer(training);
  const { enqueueSnackbar: noticeF } = useSnackbar();

  useEffect(() => {
    dispatch(loadedTraining(id));
  }, [dispatch, id]);

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };
  const addChangeChild = (item) => {
    setTrainingId(item.id);
    setChildName(`${item.children.last_name} ${item.children.first_name}`);
    setComment(item.comment === null ? "" : item.comment);
    setStatus(item.state_training_children);
    setTimeout(() => {
      setOpenChild(true);
    }, 300);
  };

  const changeStatusChild = (training) => {
    if (training.state_training_children.id === 1) {
      dispatch(
        updateStateChildTraining(training.id, id, {
          state_training_children_id: 2,
          comment: training.comment,
        })
      );
    }
    if (training.state_training_children.id === 2) {
      dispatch(
        updateStateChildTraining(training.id, id, {
          state_training_children_id: 1,
          comment: training.comment,
        })
      );
    }
  };

  /*  const maxLengthCheck = object => {
    if (object.target.value.length > object.target.maxLength) {
      object.target.value = object.target.value.slice(
        0,
        object.target.maxLength
      );
    }
  };*/

  const updateStateChild = () => {
    const payload = {
      state_training_children_id: status.id,
      comment,
    };
    dispatch(updateStateChildTraining(trainingId, id, payload));
    setOpenChild(false);
  };

  /*  const updateTraining = () => {
    dispatch(
      scheduleUpdate(id, {
        ...training,
        duration: Number(duration),
        start: date,
        filial_id: training.filial.id,
        group_id: training.group.id,
        trainer_id: training.trainer.id,
        state_schedule_id: 1
      })
    );
    setOpenChangeTime(false);
  };*/

  /*  const openDialogDate = () => {
    setDate(newTraining.start);
    setDuration(newTraining.duration);
    setOpenChangeTime(true);
  };*/

  const addEvent = () => {
    const payload = {
      content,
      id,
      creator: user.full_name,
    };
    const required = "schedule";
    dispatch(addEventTraining(required, payload));
    setContent("");
  };

  const openConfirmDialogToAddInvoice = (child) => {
    setConfirmAddInvoice(true);
    setConfirmChild(child);
  };

  const createInvoiceForChild = () => {
    const data = {
      children_id: confirmChild.id,
      group_id: newTraining.group.id,
      estimation: false,
      schedule_ids: [newTraining.id],
      is_refundable: false
    };

    dispatch(createInvoiceForTrainer(data)).then(() => {
      setConfirmAddInvoice(false);
      setConfirmChild(null);
      dispatch(loadedTraining(id));
      noticeF("Ребёнок успешно добавлен!", {
        variant: "success",
      });
    });
  };

  if (loading) {
    return (
      <div className="wrapperTraining">
        <Spinner open={true} isWhite />
      </div>
    );
  }

  return (
    <div className="wrapperTraining">
      <div className="trainingHeader">
        <div className="trainingHeaderDate">
          <span id="title">Занятие</span>
          <div id="content">
            <StatusTraining
              start={moment(newTraining.start).format("HH:mm")}
              end={moment(newTraining.start, "YYYY-mm-dd HH:mm")
                .add(newTraining.duration, "minutes")
                .format("HH:mm")}
              day={newTraining.start}
            />
            <label>{newTraining.date}</label>
          </div>
          <label className="time">
            {newTraining.startTime}-{newTraining.endTime}
          </label>
          <span id="footer">{newTraining.group.name}</span>
        </div>
        <div className="trainingHeaderInfo">
          <span>Тренер</span>
          <h3>
            {newTraining.trainer.first_name} {training.trainer.last_name}
          </h3>
          <span>Адрес</span>
          <h3>{newTraining?.filial?.address}</h3>
        </div>
      </div>
      <div className="trainingContentMobile">
        <div style={{ padding: "0 15px" }}>
          <Box className={"trainingContentMobile-tabsWrapper"}>
            <AntTabs
              value={value}
              onChange={handleChange}
              aria-label="ant example"
            >
              <AntTab label="Посещаемость" index={0} value={0} />
              <AntTab label="События" index={1} value={1} />
              <AntTab label="Группа" index={2} value={2} />
            </AntTabs>
          </Box>

          <TabPanel value={value} index={0}>
            <AttendanceTab
              newTraining={newTraining}
              addChangeChild={addChangeChild}
              changeStatusChild={changeStatusChild}
              loadingStatus={loadingStatus}
            />
          </TabPanel>

          <TabPanel value={value} index={1}>
            <EventsTab
              newTraining={newTraining}
              value={content}
              onChange={setContent}
              onClick={addEvent}
            />
          </TabPanel>

          <TabPanel value={value} index={2}>
            <GroupTab
              value={value}
              children={newTraining?.group?.children || []}
              onClick={openConfirmDialogToAddInvoice}
            />
          </TabPanel>
        </div>
      </div>
      <div className="trainingContent">
        <div className="trainingEvents">
          <h3>События</h3>
          <Scrollbars
            renderTrackHorizontal={(props) => (
              <div
                {...props}
                className="track-horizontal"
                style={{ display: "none" }}
              />
            )}
            renderThumbHorizontal={(props) => (
              <div
                {...props}
                className="thumb-horizontal"
                style={{ display: "none" }}
              />
            )}
            renderTrackVertical={(props) => (
              <div
                {...props}
                className="track-vertical"
                style={{ display: "none" }}
              />
            )}
            renderThumbVertical={(props) => (
              <div
                {...props}
                className="thumb-vertical"
                style={{ display: "none" }}
              />
            )}
          >
            <Events newTraining={newTraining} />
          </Scrollbars>
          <div className="trainingEventsActiveFooter">
            <TextField
              id="textareaTrainingEvents"
              name="addTrainingEvent"
              margin="dense"
              variant="outlined"
              multiline
              rows={3}
              placeholder="Напишите сообщение..."
              type="text"
              value={content}
              onChange={(e) => {
                setContent(e.target.value);
              }}
            />
            <Button onClick={addEvent} disabled={content === ""}>
              Отправить
            </Button>
          </div>
        </div>
        <div className="trainingAttendance">
          <h3>Ученики</h3>
          <Scrollbars>
            <AttendanceTab
              newTraining={newTraining}
              addChangeChild={addChangeChild}
              changeStatusChild={changeStatusChild}
              loadingStatus={loadingStatus}
            />
          </Scrollbars>
        </div>
      </div>

      <Dialog
        open={confirmAddInvoice}
        aria-labelledby="dialog-confirm-addInvoice"
        fullWidth
        maxWidth="xs"
        onClose={() => setConfirmAddInvoice(false)}
      >
        <DialogContent id="dialog-confirm-content">
          <span className={"confirm-addInvoice-dialog"}>
            Добавить в занятие?
          </span>
        </DialogContent>
        <DialogActions id="dialog-confirm-actions">
          <Button onClick={createInvoiceForChild} variant="contained">
            Добавить
          </Button>
          <Button
            onClick={() => setConfirmAddInvoice(false)}
            color="secondary"
            variant="contained"
          >
            Отменить
          </Button>
        </DialogActions>
      </Dialog>

      <Dialog
        open={openChild}
        aria-labelledby="form-dialog-comment"
        fullWidth
        maxWidth="xs"
      >
        <DialogTitle
          id="form-dialog-training-title"
          onClose={() => setOpenChild(false)}
        >
          <h6>{childName}</h6> <span>Посещаемость</span>
        </DialogTitle>
        <DialogContent id="form-dialog-training-content">
          <div className="headerContent">
            <span>Ребенок посетил занятие?</span>
            <Select
              id="select"
              margin="dense"
              variant="outlined"
              size="small"
              onChange={(e) =>
                setStatus(
                  state_training_children.find(
                    (el) => el.name === e.target.value
                  )
                )
              }
              value={
                state_training_children.find((el) => el.id === status.id)?.name
              }
            >
              {state_training_children.map((option) => (
                <MenuItem
                  key={option.id}
                  value={option.name}
                  style={{
                    color: "#7C7C7C",
                    fontSize: "12px",
                  }}
                >
                  {option.name}
                </MenuItem>
              ))}
            </Select>
          </div>
          <TextField
            className="commentTraining"
            name="commentTraining"
            margin="dense"
            variant="outlined"
            placeholder="Добавить комментарий"
            multiline
            rows={3}
            value={comment}
            onChange={(e) => setComment(e.target.value)}
            type="text"
            fullWidth
          />
        </DialogContent>
        <DialogActions id="confirm-action-comment">
          <Button
            onClick={updateStateChild}
            color="primary"
            variant="contained"
          >
            Сохранить
          </Button>
        </DialogActions>
      </Dialog>
      {/*<Dialog
        open={openChangeTime}
        aria-labelledby="form-dialog-training-time"
        fullWidth
        maxWidth="sm"
      >
        <DialogTitle
          id="form-dialog-training-time-title"
          onClose={() => setOpenChangeTime(false)}
        >
          <h6>Назначить новое время</h6>
        </DialogTitle>
        <DialogContent id="form-dialog-training-time-content">
          <div className="dateTrainingInput">
            <label>День</label>
            <TextField
              name="date"
              className="date"
              margin="dense"
              type="date"
              variant="outlined"
              defaultValue={moment(training.start).format("YYYY-MM-DD")}
              onChange={e => {
                setDate(
                  `${e.target.value} ${moment(newTraining.start).format(
                    "HH:mm:ss"
                  )}`
                );
              }}
            />
          </div>
          <div className="timeTrainingInput">
            <label>Время</label>
            <TextField
              name="time"
              margin="dense"
              variant="outlined"
              defaultValue={newTraining.startTime}
              onChange={e => {
                setDate(
                  `${moment(date).format("YYYY-MM-DD")} ${e.target.value}:00`
                );
              }}
              type="time"
            />
          </div>
          <div className="durationTrainingInput">
            <label>Длительность</label>
            <input
              type="number"
              className="duration"
              onInput={maxLengthCheck}
              maxLength="3"
              value={duration}
              onChange={e => {
                setDuration(e.target.value);
              }}
            />
          </div>
        </DialogContent>
        <DialogActions id="confirm-action-time">
          <Button onClick={updateTraining} color="primary" variant="contained">
            Изменить
          </Button>
        </DialogActions>
      </Dialog>*/}
    </div>
  );
};

export default compose(withApiService())(withRouter(TrainingTrainer));
